import React from 'react';
export const Nav00DataSource = {
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children:
      'https://www.wshoto.com/resource/website_new/images/index-nav-logo.png?v=1',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '/wi_website_index.php',
          children: [
            {
              children: (
                <>
                  <p>首页</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/wi_website_product.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>产品中心</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/wi_website_case.php',
          children: [
            {
              children: (
                <>
                  <p>案例中心</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
        subItem: null,
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/wi_website_product-manual.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>帮助中心</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k315jln721q',
        className: 'header0-item',
        children: {
          href: '/wi_website_joinin.php',
          children: [
            {
              children: (
                <>
                  <p>合作伙伴</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k315kgkx2m',
        className: 'header0-item',
        children: {
          href: '/wi_website_news.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>企微学院</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k315kqbkra',
        className: 'header0-item',
        children: {
          href: '/wi_website_aboutus.php',
          children: [
            {
              children: (
                <>
                  <p>
                    <span>了解微盛</span>
                    <br />
                  </p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~k481t05n1i',
        className: 'header0-item',
        children: {
          href: '/wi_user_login.php',
          children: [
            {
              children: (
                <>
                  <p>登录</p>
                </>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
};
export const Banner30DataSource = {
  wrapper: { className: 'banner3 k31bfwc7k9-editor_css' },
  textWrapper: {
    className: 'banner3-text-wrapper k3166u8abp-editor_css',
    children: [
      {
        name: 'nameEn',
        className: 'banner3-name-en k31bmzd8ay-editor_css',
        children: (
          <>
            <p>
              <br />
            </p>
          </>
        ),
      },
      {
        name: 'slogan',
        className: 'banner3-slogan k3161gnsy9-editor_css',
        children: '微盛SCRM小程序全面深度集成企业微信',
        texty: true,
      },
      {
        name: 'name',
        className: 'banner3-name k47wsih1pkf-editor_css',
        children: (
          <>
            <p>
              企业微信+小程序 打造企业数字化转型闭环<br />
            </p>
          </>
        ),
      },
      {
        name: 'button',
        className: 'banner3-button k32rfy3lf56-editor_css',
        children: (
          <>
            <p>免费试用</p>
          </>
        ),
        href: 'https://www.wshoto.com/wi_user_login.php',
        target: '_blank',
        type: 'primary',
      },
      {
        name: 'button~k3168n14y2',
        className:
          'ant-btn-primary ant-btn banner3-button ant-btn-default k3168ouqrl7-editor_css',
        children: (
          <>
            <p>立即咨询</p>
          </>
        ),
        type: 'default',
        href: 'http://wpa.qq.com/msgrd?v=3&amp;uin=&amp;site=qq&amp;menu=yes',
        target: '_blank',
      },
    ],
  },
};
export const Feature05DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper k5m5zdwc0m-editor_css',
  },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>微盛企微管家 - 首个企业微信第三方工具&nbsp;</p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 24,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m5ycus5gi-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/9ee3e53311e42e8a9a5f77ecd1ec5cc2.png',
            },
          ],
        },
      },
    ],
  },
};
export const Feature07DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>如何加客户微信到企业微信上</p>
          </>
        ),
      },
      {
        name: 'title~k5m6npd5r7l',
        className: 'k5m6nrxsrpn-editor_css',
        children: (
          <>
            <p>方式一：素材海报加客户微信&nbsp;</p>
          </>
        ),
      },
      {
        name: 'title~k5m6nsfy5hg',
        className: 'k5m6p9osz9f-editor_css',
        children: (
          <>
            <p>
              上万张预置海报，也可自定义上传海报模板。移动端生成海报，支持自定义二维码和一键生成企业微信二维码
            </p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 24,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m6taidnm7-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/5c7d44c22d9dc9eb780618a7fde62cf8.png',
            },
            {
              name: 'content',
              children: (
                <>
                  <p>
                    线上线下多渠道进行宣传，通过优惠信息等吸引用户添加好友。&nbsp;
                  </p>
                </>
              ),
              className: 'k5m6rxnyzx-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m6wreub8-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/dd520758693c60a927f1617d9182411e.png',
            },
          ],
        },
      },
      {
        name: 'block~k5m6ykegjgu',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m6wreub8-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/f00537c4808b125dd1e061770d44027c.png',
            },
          ],
        },
      },
      {
        name: 'block~k5m6ykwg8yf',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m6wreub8-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/cd10596f1314a33ac291259438b0d8ca.png',
            },
          ],
        },
      },
      {
        name: 'block~k5m6ylnryxe',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m6wreub8-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/415309ecc06a69b0b4b7eb5c1d3b076a.png',
            },
          ],
        },
      },
    ],
  },
};
export const Feature08DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>方式二：营销活动加客户微信</p>
          </>
        ),
        className: 'k5m71ey5w1m-editor_css',
      },
      {
        name: 'title~k5m731d3ot',
        className: 'k5m731zu1hs-editor_css',
        children: (
          <>
            <p>
              渠道二维码添加好友，自动下发个性化营销活动欢迎语，领取活动奖励
            </p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m744mfehg-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/09de4f23514e2ea08a3d074a1079e8d9.png',
            },
          ],
        },
      },
      {
        name: 'block~k5m75rh253j',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m744mfehg-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/0729386575289f2b4672c7bef1c904be.png',
            },
          ],
        },
      },
      {
        name: 'block~k5m75s067k',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m744mfehg-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/ec4e9d6ec93c3ceb918f0e3a57df5668.png',
            },
          ],
        },
      },
      {
        name: 'block~k5m75sfz2kp',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m744mfehg-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/91a540257b03c920832e66f038f1ec75.png',
            },
          ],
        },
      },
    ],
  },
};
export const Feature06DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper k5m6a6xknpd-editor_css',
  },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>方式三：已有渠道加客户微信</p>
          </>
        ),
        className: 'k5m651hiuul-editor_css',
      },
      {
        name: 'title~k5m65qczdib',
        className: 'k5m65sv4vcb-editor_css',
        children: (
          <>
            <p>
              小程序[联系我]、公众号、小程序客服、朋友圈广告等途径与渠道投放添加客户微信。
            </p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper k62y7uk9qub-editor_css',
    children: [
      {
        name: 'block0',
        className: 'content0-block k62yo16x83q-editor_css',
        md: 24,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'content',
              children: (
                <>
                  <p>
                    <br />
                  </p>
                </>
              ),
              className: 'k5m66r2etsm-editor_css',
            },
          ],
        },
      },
      {
        name: 'block~k5m69du2gf',
        className: 'content0-block k62ytopdwbf-editor_css',
        md: 24,
        xs: 24,
        children: {
          className: 'content0-block-item k62z35vy3z-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m64w5gvgf-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/078611e6a3398f17e476fe9d93e62cb6.png',
            },
          ],
        },
      },
      {
        name: 'block~k62yz8hm5pd',
        className: 'content0-block k62ytopdwbf-editor_css',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item k62z3pv6pxq-editor_css',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m64w5gvgf-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/64d8ef0ac69e8b158fcf994b0766a846.png',
            },
          ],
        },
      },
      {
        name: 'block~k62yz9i016',
        className: 'content0-block k62ytopdwbf-editor_css',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m64w5gvgf-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/ac3f3c47e55ebc7a8a8924303fafa7f6.png',
            },
          ],
        },
      },
      {
        name: 'block~k62yzanekou',
        className: 'content0-block k62ytopdwbf-editor_css',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m64w5gvgf-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/2387e353ca6fb1c7f091c837e35bd843.png',
            },
          ],
        },
      },
    ],
  },
};
export const Feature09DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>如何做好客户管理及互动</p>
          </>
        ),
      },
      {
        name: 'title~k5m7912w85m',
        className: 'k5m793rp48i-editor_css',
        children: (
          <>
            <p>客户管理：指定渠道及欢迎语&nbsp;</p>
          </>
        ),
      },
      {
        name: 'title~k5m79xnb9sh',
        className: 'k5m79ziifqp-editor_css',
        children: (
          <>
            <p>不同渠道设置不同的欢迎语，还可以统计分析渠道效果</p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m7ajv4pn-editor_css',
              children:
                'https://www.wshoto.com/attachment/website/file/manage/1.png',
            },
            {
              name: 'title',
              className: 'content0-block-title k5m7b0ez3k-editor_css',
              children: (
                <>
                  <p>推营销活动</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k5m7cio9uik',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m7ajv4pn-editor_css',
              children:
                'https://www.wshoto.com/attachment/website/file/manage/2.png',
            },
            {
              name: 'title',
              className: 'content0-block-title k5m7b0ez3k-editor_css',
              children: (
                <>
                  <p>推营销活动</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k5m7cj6a0sh',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m7ajv4pn-editor_css',
              children:
                'https://www.wshoto.com/attachment/website/file/manage/3.png',
            },
            {
              name: 'title',
              className: 'content0-block-title k5m7b0ez3k-editor_css',
              children: (
                <>
                  <p>官网推送</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k5m7cjwbkpg',
        className: 'content0-block',
        md: 6,
        xs: 12,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m7ajv4pn-editor_css',
              children:
                'https://www.wshoto.com/attachment/website/file/manage/4.png',
            },
            {
              name: 'title',
              className: 'content0-block-title k5m7b0ez3k-editor_css',
              children: (
                <>
                  <p>营销海报推送</p>
                </>
              ),
            },
          ],
        },
      },
    ],
  },
};
export const Feature010DataSource = {
  wrapper: { className: 'home-page-wrapper content0-wrapper' },
  page: { className: 'home-page content0' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>客户管理:1对多企业群发，1分钟确认群发</p>
          </>
        ),
        className: 'k5m7d5l1epo-editor_css',
      },
      {
        name: 'title~k5m7f2ptvt',
        className: 'k5m7fab4n1m-editor_css',
        children: (
          <>
            <p>
              根据添加人或者标签筛选目标客户，可群发文字、图片、网页、小程序等内容，统一通知成员一键群发，实现1小时到1分钟确认群发
            </p>
            <p>更多方案更新中...</p>
          </>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block',
        md: 12,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m7fxdz3c-editor_css',
              children:
                'https://www.wshoto.com//attachment/website/file/%E5%AE%98%E7%BD%91%E5%9B%BE%E7%89%87/a61760d4382f40ff4440afabf212471a.png',
            },
            {
              name: 'title',
              className: 'content0-block-title k5m7gvvtsqc-editor_css',
              children: (
                <>
                  <p>筛选目标人群，编辑群发内容</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k5m7g624iv',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m7i7t3m3g-editor_css',
              children:
                'https://www.wshoto.com/attachment/website/file/manage/5.png',
            },
            {
              name: 'title',
              className: 'content0-block-title k5m7j5qnkw-editor_css',
              children: (
                <>
                  <p>成员收到群发通知</p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block~k5m7k0sh6pf',
        className: 'content0-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon k5m7i7t3m3g-editor_css',
              children:
                'https://www.wshoto.com/attachment/website/file/manage/6.png',
            },
            {
              name: 'title',
              className: 'content0-block-title k5m7j5qnkw-editor_css',
              children: (
                <>
                  <p>群发给目标客户</p>
                </>
              ),
            },
          ],
        },
      },
    ],
  },
};
export const Content110DataSource = {
  OverPack: {
    className: 'home-page-wrapper content11-wrapper k317ziqoic-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <>
            <p>Hi，现在注册，享好礼！</p>
          </>
        ),
        className: 'title-h1 k318183k996-editor_css',
      },
    ],
  },
  button: {
    className: '',
    children: {
      a: {
        className: 'button',
        href: 'https://www.wshoto.com/wi_user_login.php',
        children: (
          <>
            <p>即刻开启私域</p>
          </>
        ),
        target: '_blank',
        type: 'default',
      },
    },
  },
};
export const Footer10DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page k317qox00p-editor_css',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block k319huz377-editor_css',
        title: {
          className: 'logo',
          children:
            'https://www.wshoto.com/resource/website_new/images/index-nav-logo.png',
        },
        childWrapper: {
          className: 'slogan k31a2k968um-editor_css',
          children: [
            {
              name: 'content0',
              children: (
                <>
                  <p>基于企业微信的行业SCRM解决方案</p>
                </>
              ),
              className: 'k31a2veocw6-editor_css',
            },
            {
              name: 'image~k319ceqayh',
              className: 'k319cpthlg-editor_css',
              children: '',
            },
            {
              name: 'image~k319cgwc11n',
              className: 'k319ciwpn89-editor_css',
              children: '',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block k49b5xaw2ct-editor_css',
        title: {
          children: (
            <>
              <p>云业务</p>
            </>
          ),
        },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: 'https://www.wshoto.com/wi_website_qcloudso.php',
              children: (
                <>
                  <p>联合解决方案</p>
                </>
              ),
              className: 'k317s8b5dk8-editor_css',
              target: '_blank',
            },
            {
              name: 'link1',
              href: 'https://www.wshoto.com/wi_website_shopping.php',
              children: (
                <>
                  <p>优惠购买</p>
                </>
              ),
              className: 'k317scp5att-editor_css',
              target: '_blank',
            },
            {
              name: 'link~k32seujj06n',
              href:
                'https://qcloud.wshoto.com/wshotocloud/activity.wshotocloud.com/free_test/index.html',
              children: (
                <>
                  <p>免费体验</p>
                </>
              ),
              className: 'k317scp5att-editor_css',
              target: '_blank',
            },
          ],
          className: 'k317s8vk249-editor_css',
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <>
              <p>招商加盟</p>
            </>
          ),
        },
        childWrapper: {
          children: [
            {
              href: 'https://www.wshoto.com/wi_website_joinin.php',
              name: 'link0',
              children: (
                <>
                  <p>产品优势</p>
                </>
              ),
              className: 'k49blu3q21f-editor_css',
            },
            {
              href: 'https://www.wshoto.com/wi_website_joinin.php',
              name: 'link1',
              children: (
                <>
                  <p>扶持体系</p>
                </>
              ),
              className: 'k49bmjmeku-editor_css',
            },
            {
              href: '#',
              name: 'link~k32seoc7wm',
              children: (
                <>
                  <p>
                    <br />
                  </p>
                </>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <>
              <p>了解微盛</p>
            </>
          ),
        },
        childWrapper: {
          children: [
            {
              href: 'https://www.wshoto.com/wi_website_aboutus.php',
              name: 'link0',
              children: (
                <>
                  <p>关于我们</p>
                </>
              ),
              className: 'k319fv578f-editor_css',
            },
            {
              href: 'https://www.wshoto.com/wi_website_advantage.php',
              name: 'link1',
              children: (
                <>
                  <p>我们的优势</p>
                </>
              ),
              className: 'k49bnhbvx8-editor_css',
            },
            {
              href: 'https://www.wshoto.com/wi_website_news.php',
              name: 'link~k32sfv93meu',
              children: (
                <>
                  <p>新闻中心</p>
                </>
              ),
              className: 'k49bnjbtui9-editor_css',
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright k47vbijlci9-editor_css',
    children: (
      <>
        <p>
          Copyright ©江苏微盛网络科技有限公司&nbsp;&nbsp;<a
            href="http://www.beian.miit.gov.cn/"
            target="_blank"
          >
            苏ICP备15043910-2号
          </a>
        </p>
      </>
    ),
  },
};
